import { AppError } from '~/shared/error/AppError';

export class AppSwitchError extends AppError {
  constructor() {
    super('error.APP_SWTICH_ERROR');
  }
}
